import Diziner from '@diziner/Diziner';
import { ElementQueries } from 'css-element-queries';
document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded');
    const diziner = new Diziner();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    diziner.loadIssue(parseInt(browser_options.issueId));
    // TODO: Remove Diziner from global-space
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window['Diziner'] = diziner;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window['ElementQueries'] = ElementQueries;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    PubSub.subscribeAll((msg, data) => console.log('PubSub: ' + msg, data));
});
